




import Vue from 'vue'
import {mapActions} from 'vuex'

export default Vue.extend({
    data: () => ({
        /**
         * The Auth2 parameters, as seen on
         * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
         * As the very least, a valid client_id must present.
         * @type {Object}
         */
        googleSignInParams: {
            client_id: '1032475358248-if8rhn1r1827bl4goa4cs7opanrjiaih.apps.googleusercontent.com'
        }
    }),
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('auth', ['onGoogleSignInSuccess', 'onGoogleSignInError'])
    }
})
